import dayjs, { Dayjs } from 'dayjs';

export type PrecedingSurveyCloseDateDto = {
  closeDate: string | null;
};

export const mapPrecedingSurveyCloseDateDtoToModel = (
  dto: PrecedingSurveyCloseDateDto,
): Dayjs | null => (dto?.closeDate ? dayjs(dto.closeDate.split(' ')[0]) : null);
